import './WhatsAppButton.css';

const WhatsAppButton = () => (
  <a
    href="https://wa.me/918769254249"
    className="whatsapp-btn"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat with us on WhatsApp"
  >
    {/* Official WhatsApp logo mark */}
    <svg
      className="whatsapp-btn__icon"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="16" cy="16" r="16" fill="#25D366" />
      <path
        d="M23.5 8.5A10.44 10.44 0 0 0 16 5.5a10.5 10.5 0 0 0-9.08 15.75L5.5 26.5l5.4-1.41A10.5 10.5 0 0 0 26.5 16a10.44 10.44 0 0 0-3-7.5z"
        fill="#25D366"
      />
      <path
        d="M23.5 8.5A10.44 10.44 0 0 0 16 5.5a10.5 10.5 0 0 0-9.08 15.75L5.5 26.5l5.4-1.41A10.5 10.5 0 0 0 16 26.5a10.5 10.5 0 0 0 10.5-10.5 10.44 10.44 0 0 0-3-7.5z"
        fill="white"
        fillOpacity="0"
      />
      <path
        d="M22.11 9.88A8.75 8.75 0 0 0 16 7.25a8.75 8.75 0 0 0-7.59 13.13l.18.28-1.04 3.8 3.9-1.02.27.16A8.75 8.75 0 0 0 16 24.75a8.75 8.75 0 0 0 8.75-8.75 8.71 8.71 0 0 0-2.64-6.12z"
        fill="white"
      />
      <path
        d="M20.93 19.3c-.26.73-1.52 1.4-2.09 1.49-.54.08-1.22.11-1.97-.12a18.1 18.1 0 0 1-1.78-.66c-3.13-1.35-5.17-4.5-5.33-4.71-.15-.21-1.27-1.69-1.27-3.22s.8-2.28 1.09-2.59a1.15 1.15 0 0 1 .83-.39c.21 0 .41 0 .59.01.19 0 .44-.07.69.53.26.62.87 2.12.95 2.28.08.15.13.34.03.54-.1.21-.15.34-.3.52-.14.18-.3.4-.43.54-.14.14-.29.3-.12.59.17.29.74 1.22 1.59 1.97 1.09.98 2.01 1.28 2.3 1.42.29.15.46.12.63-.07.18-.2.74-.86.94-1.16.2-.29.39-.24.66-.14.26.1 1.67.79 1.96.93.29.15.48.22.55.34.07.12.07.69-.19 1.41z"
        fill="#25D366"
      />
    </svg>

  </a>
);

export default WhatsAppButton;
